import { LoadingButton } from "@mui/lab";
import { Box, Button, Dialog, DialogContent, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { DocumentRepoService } from "../../../Component/Api/DocumentRepo/DocumentRepoService";
import { ConfirmationDialog } from "../../../Component/Common/Components/ConfirmationDialog";
import { MDBox } from "../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { UploadButton } from "../../../Component/Common/Components/UploadButton/UploadButton";
import { DocumentRepo } from "../../../Component/Model/Dto/EmploymentEquity/DocumentRepo";
import { CustomDialogTitle } from "../../Common/Custom/CustomDialogTitle";
import { DocumentRepoWithActionsTableMapper } from "./DocumentRepoColumn";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { BasicDataTable } from "../../../Component/Common/Components/BasicDataTable/BasicDataTable";
import { MDButton } from "../../../Component/Common/Components/MDButton";
import { toast } from "react-toastify";

interface IProps {
    documentData: DocumentRepo.Document[];
    sectionId: number;
    sectionName: string;
    refreshData: () => void;
}

export const DocumentRepoSection = (props: IProps) => {

    const [selectedDocumentId, setSelectedDocumentId] = useState<number>(0);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [openAddDocumentDialog, setOpenAddDocumentDialog] = useState<boolean>(false);
    const [description, setDescription] = useState<string>("");
    const deleteSection = async (id: number) => {
        setSelectedDocumentId(id);
        setShowConfirmationDialog(true);
    }

    const handleDelete = async () => {
        setShowConfirmationDialog(false);
        setIsLoading(true);
        try {
            await DocumentRepoService.DeleteDocumentItem(selectedDocumentId);
            toast.success('Document deleted');
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
        props.refreshData();
    }

    const addDocumentItem = async (document: any) => {

        const item: DocumentRepo.InsertItemParameters = {
            id: props.sectionId,
            description: description
        }
        const headers = { 'Content-Type': 'multipart/form-data' };
        let formData = new FormData();
        formData.append(document.name, document);
        setIsSubmitting(true);
        try {
            await DocumentRepoService.InsertDocumentSectionItem(item, formData, headers);
            toast.success('Successfully upoaded document');
        } catch (error) {
            console.log(error)
        } finally {
            setOpenAddDocumentDialog(false);
            setIsSubmitting(false);
        }
        props.refreshData();
    }

    const onFileChange = (event: any) => {
        if (event.target) {
            const newDocument = event.target.files[0];
            const fileSizeInKB = Math.ceil(newDocument.size / 1024);
            const maxFileSizeInKB = 1024 * 20;
            var fileExt = newDocument.name.split('.').pop();
            const allowedFileTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'zip', 'rar']
            if (allowedFileTypes.includes(fileExt)) {

                if (fileSizeInKB > maxFileSizeInKB) {
                    toast.error("File is bigger than 20MB");
                    return;
                }
                else {
                    addDocumentItem(newDocument)
                    return;
                }
            }
            else {
                toast.error("Unsupported file type. Permitted file types are: .jpeg, .jpg, .png, .gif, .bmp, .tiff, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar");
                return;
            }
        }
    }

    const onDescriptionChange = (event: any) => {
        setDescription(event.target.value);
    }

    const handleView = (id: number) => {
        DocumentRepoService.ViewDocumentItem(id);
    }

    const handleCloseConfirmation = () => {
        setShowConfirmationDialog(false);
        setSelectedDocumentId(0);
    }

    const closeModal = () => {
        setSelectedDocumentId(0);
        setOpenAddDocumentDialog(false);
        props.refreshData();
    }

    const documentTable = DocumentRepoWithActionsTableMapper(props.documentData, handleView, deleteSection);
    return (
        <>
            {
                documentTable !== undefined && documentTable.rows.length > 0 ?
                    <BasicDataTable
                        table={documentTable}
                        isLoading={isLoading}
                    /> :
                    <MDBox paddingLeft="20px">
                        <MDTypography variant="subtitle1">
                            {"No Documents"}
                        </MDTypography>
                    </MDBox>
            }

            <Dialog open={openAddDocumentDialog} onClose={() => { closeModal() }} aria-labelledby="form-dialog-title" maxWidth='sm' disableEnforceFocus fullWidth>
                <CustomDialogTitle id="customized-dialog-title" onClose={() => closeModal()}>
                    {props.sectionName}
                </CustomDialogTitle>
                <DialogContent>
                    <Box>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} mt={2}>
                                <TextField fullWidth variant='outlined' value={description} name="description" label="Document Description" onChange={onDescriptionChange} />
                            </Grid>
                            <Grid item xs={12} sm={12} mt={2}>
                                <UploadButton
                                    id='upload-file' onChange={onFileChange} type='file'
                                    accept=".jpeg, .jpg, .png, .gif, .bmp, .tiff, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
                                    IconView={FileUploadIcon} text='Select file (Max 20MB)'
                                    loading={isSubmitting}
                                    color="info"
                                    disabled={false} />
                            </Grid>
                        </Grid>
                    </Box >
                </DialogContent>
            </Dialog>
            <MDBox padding="20px" >
                <MDButton variant="contained" color="primary" onClick={() => { setOpenAddDocumentDialog(true) }} >Add Document </MDButton>
            </MDBox>
            <ConfirmationDialog
                showDialog={showConfirmationDialog}
                handleAccept={handleDelete}
                handleCancel={handleCloseConfirmation}
                heading={"Confirm Delete"}
                message={"Are you sure you want to delete the selected document?"}
            />
        </>


    )
}